export default "__VITE_ASSET__DpP_kiaR__"